module.exports = __webpack_public_path__ + "static/media/FuturaBT-01.cbd31176.svg";